import '../../../../Events.js'

/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

const MODE_VIEW = "view";
const MODE_EDIT = "edit";

/**
 * @class
 * @extends Events
 */
UI.Widget.Forms.Control.Base = Class(Events, /** @lends UI.Widget.Forms.Control.Base.prototype */ {
    parent: null,
    $control: null,
    control: null,
    target: null,
    disabled: false,
    required: false,

    /**
     * @type {string}
     */
    mode: MODE_EDIT,
    smartControl: true,

    /**
     * @type {*} Customizer which is invoked to produce the objects of target path
     */
    pathCustomizer: Object,

    initialize: function(parent, $control) {
        $control = $($control);

        this.parent = parent;
        this.$control = $control;
        this.control = $control[0];
        this.target = $control.attr("target");
        this.disabled = $control.attr("disabled") !== undefined;
        this.required = $control.attr('required') === 1
        this.pathCustomizer = _.get(GLOBAL, $control.attr('path-customizer')) || this.pathCustomizer;

        this.mode = (this.$control.attr('mode')?this.$control.attr('mode'):this.mode);

		if (this.$control.attr("def-value") && !this.getValue()) {
			this.setValue(this.$control.attr("def-value"));
		}
    },

    bind: function() {
        this.emit("bind");
    },

    unbind: function() {
        this.emit("unbind");
    },

    update: function() {
        this.emit("update", this.getValue());
    },

    parseTarget: function(target) {
        if (!target) {
            target = this.target;
        }

        var regExp = new RegExp("\\[([^\\]]+)\\]", "g");
        var match;

        while (match = regExp.exec(target)) {
            var group = match[1];
            var index = this.groupIndex(group);

            if (~index) {
                target = target.replace(group, index);
            }
        }

        return target;
    },

    getValue: function() {
        var value, target = null;

        try {
            target = this.parseTarget();

            value = _.get(this.parent, target);
        } catch (err) {
            console.error("Control.getValue() failed", target, err.stack);
        }

        return value;
    },

    setValue: function(value, update) {
        if (this.disabled) {
            return;
        }

        var args = {
            control: this,
            value: value != null ? value : undefined,
            update: update || false
        };

        var target = null;

        try {
            target = this.parseTarget();

            if (this.parent && Util.isFunction(this.parent.onControlPreSetValue)) {
                this.parent.onControlPreSetValue(args);
            }

            _.setWith(this.parent, target, args.value, this.pathCustomizer);

            if (this.parent && Util.isFunction(this.parent.onControlSetValue)) {
                this.parent.onControlSetValue(args);
            }

            if (args.update) {
                this.update();
            }
        } catch (err) {
            console.error("Control.setValue() failed", target, value, err.stack);
        }

        return value;
    },

    getIndex: function() {
        var target = this.target;
        var returnindex = null;

        var regExp = new RegExp("\\[([^\\]]+)\\]", "g");
        var match;

        while (match = regExp.exec(target)) {
            var group = match[1];
            var index = this.groupIndex(group);

            if (~index) {
                returnindex = index;
            }
        }

        return returnindex;
    },


    groupIndex: function(group) {
        var selector = "[control-group=\"" + group + "\"]";
        var $group = this.$control.parentsUntil(selector).last().parent();

        if (!$group.length) {
            return -1;
        }

        return $group.parent().children().index($group);
    },

    getTarget: function() {
        return this.target;
    },

    setMode (mode) {
        this.mode = mode

        if (mode === UI.Widget.Forms.Control.Base.Mode.Edit) {
            this.editMode()
        } else {
            this.viewMode()
        }
    },

    editMode () {},

    viewMode () {},
});



UI.Widget.Forms.Control.Base.Static( /** @lends UI.Widget.Forms.Control */ {
    /**
     * @enum {string}
     */
    Mode: {
        View: MODE_VIEW,
        Edit: MODE_EDIT
    }
});
